
export const GET_SHARED_DASHBOARD_DATA_REQUEST = 'get_shared_dashboard_data_request';
export const GET_SHARED_DASHBOARD_DATA_SUCCESS = 'get_shared_dashboard_data_success';
